import { Endpoints } from '../../misc'
import { Pagination, ReportData } from '@/domain/entities/Main'
import ApiService from '../../services/ApiService'
import { MainMapper } from '@/data/persistences/mappers/MainMapper'
import { MainRepositoryInterface } from '@/data/persistences/repositories/contracts/MainRepositoryInterface'
import { onGetWidgetDownloadData } from '../../misc/mocks/WidgetDownload'

export class MainApiRepository implements MainRepositoryInterface {
  private service: ApiService
  private mapper: MainMapper

  constructor(service: ApiService, mapper: MainMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getReportList(params: Pagination): Promise<ReportData> {
    const resp = await this.service.invoke(
      'get',
      `${Endpoints.Route.REPORTS}?${params.toQuery()}`
    )

    return this.mapper.convertReportListFromApi(resp)
  }
}
